export default __webpack_public_path__ + "static/media/Resource-Icons-Child-Development-transparent.9d39e266.png";